module.exports = __webpack_public_path__ + "media/images/lb/937-3ca0ab66b3a82e8a11d73ecc1cb02bce.svg";